import { FlightTravelClass } from '@lmn/common-search-widget/components/ClassButtons/services/types';
import { FlightClassType } from '@/app/components/search/utils/FlightClassType';

const getCSWFlightClass = (flightClass?: FlightClassType): FlightTravelClass => {
  switch (flightClass) {
    case FlightClassType.BUSINESS:
      return FlightTravelClass.Business;
    case FlightClassType.ECONOMY:
      return FlightTravelClass.Economy;
    case FlightClassType.FIRST_CLASS:
      return FlightTravelClass.FirstClass;
    case FlightClassType.PREMIUM_ECONOMY:
      return FlightTravelClass.PremiumEconomy;
    case FlightClassType.ANY:
    default:
      return FlightTravelClass.AnyClass;
  }
};

export default getCSWFlightClass;
